import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  expertiseList: Array<string>;


  title = "Vishal Jaiswal Resume";
  firstName = "Vishal";
  lastName = "Jaiswal";
  emailId = "vishaljaiswal5000@gmail.com";
  aboutMe = `I have over 4 years of experience as a software engineer and have
  worked at mid-level organization and as a freelancer. While I'm a
  proficient full stack developer.

  I love building things. While hard engineering problems are often
  intrinsically fun to tackle. I'm most attracted to solving real
  customer problems with a business justification.
`;




  constructor() { }

  ngOnInit(): void {
    this.expertiseList = new Array<string>();
    this.expertiseList = [
      "Building scalable Back-End services",
      "T-SQL and Dynamic query.",
      "Front-End Development",
      "Windows Desktop Application",      
    ];
  }

}
